/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { DataGrid } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import { withTheme } from '@emotion/react';
import { TABLE_HEADER_FONT_COLOR } from 'modules/common/constants/style';
import { selectEventCategoryConfigurations } from 'modules/event-configuration/selectors';
import MAJOR_CATEGORY_COLUMNS from 'modules/common/constants/major-event-categories-table';
/**
 * Table to display major event categories
 */
const MajorEventsTableView = ({ isShow, setSelectedMajorEventId }) => {
  const eventCategories = useSelector(selectEventCategoryConfigurations);
  //
  const [filteredEventCategories, setFilteredEventCategories] = useState([]);
  //
  useEffect(() => {
    const formattedEventCategories = eventCategories?.results?.map((eventCategory) => ({
      id: eventCategory?.id,
      name: eventCategory?.name,
    }));
    setFilteredEventCategories(formattedEventCategories);
  }, [eventCategories]);
  //
  const onSelectedRowChange = (ids) => {
    if (ids?.length) {
      setSelectedMajorEventId(ids[0]);
      isShow(true);
    }
  };
  //
  return (
    <Box sx={{ height: 600, width: '100%' }}>
      <DataGrid
        sx={{
          '& .super-app-theme--header': {
            backgroundColor: 'white',
            color: TABLE_HEADER_FONT_COLOR,
          },
          '& .MuiDataGrid-main': {
            backgroundColor: 'white',
          },
          '.MuiDataGrid-footerContainer': {
            backgroundColor: 'white',
          },
        }}
        columnVisibilityModel={{
          id: false,
        }}
        rowHeight={50}
        rows={filteredEventCategories || []}
        columns={MAJOR_CATEGORY_COLUMNS}
        onSelectionModelChange={onSelectedRowChange}
      />
    </Box>
  );
};
//
export default withTheme(MajorEventsTableView);
